import { TemplateElement, defineElement, html } from '@webtides/element-js';
import '../../../elements/loading-spinner/loading-spinner';
import style from './product-list.css';

class ProductList extends TemplateElement {
    constructor() {
        super({ shadowRender: false, deferUpdate: true, autoUpdate: false, styles: [style] });
    }

    properties() {
        return {
            products: [],
            activeFrame: false,
            activeColorKey: false,
        };
    }

    connected() {
        if (this.products.length > 0) {
            this.requestUpdate();
        }
    }

    watch() {
        return {
            products: () => this.requestUpdate(),
            activeFrame: () => this.requestUpdate(),
            activeColorKey: () => this.requestUpdate(),
        };
    }

    get showSpacerElement() {
        return this.products.some(product => {
            return Object.keys(product.frames).some(frame => product.frames[frame].price?.discount ?? false);
        });
    }

    getTransitionDelay(index = 0) {
        if (index > 5) {
            return '0ms';
        }
        return `${index * 150}ms`;
    }

    template() {
        return html`
            ${this.products.map(
                (product, index) => html`
                    <product-card
                        current-frame-id=${this.activeFrame}
                        active-color-key=${this.activeColorKey}
                        class="block"
                        .frames="${product.frames}"
                        has-frame-selector="${product.hasFrameFilter !== false}"
                        name="${product.name}"
                        .description="${product.description}"
                        show-spacer-element="${this.showSpacerElement}"
                    ></product-card>
                `
            )}
        `;
    }
}

defineElement('product-list', ProductList);
